import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule } from '@angular/forms';
// import { MssoModule } from 'ngpd-merceros-msso-fe-components';



import { AuthContainerComponent } from './auth.container';
import { AuthEffects } from './auth.effects';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RouterModule } from '@angular/router';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { AdditionalAuthenticationComponent } from './additional-authentication/additional-authentication.component';
import { EmailSentComponent } from './email-sent/email-sent.component';
import { SessionComponent } from './session/session.component';
import { ContactUsModule } from '../help-and-contacts/contact-us/contact-us.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthenticationModule } from 'ngpd-merceros-authentication-fe-components';
import { AuthService } from './auth.service';
// import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalModule } from 'atlas-modal';
import { ButtonModule } from 'atlas-button';
import { IconModule } from 'atlas-icon';
import { FieldModule } from 'atlas-field';
import { CheckboxModule } from 'atlas-checkbox';

export const COMPONENTS = [
  AuthContainerComponent,
  LoginComponent,
  ResetPasswordComponent,
  TermsAndConditionsComponent,
  AdditionalAuthenticationComponent,
  EmailSentComponent,
  SessionComponent,
  ForgotPasswordComponent
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    RouterModule,
    // MercerOSModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedModule,
    // MssoModule,
    EffectsModule.forFeature([AuthEffects]),
    ContactUsModule,
    AuthenticationModule,
    ModalModule,
    ButtonModule,
    IconModule,
    FieldModule,
    CheckboxModule
  ],
  exports: COMPONENTS,
  providers: [AuthService],
  bootstrap: [],
  // schemas: [
  //   CUSTOM_ELEMENTS_SCHEMA
  // ]
})
export class AuthModule {
}
